export const MessageFrequencyType = {
	XMessagesEveryYWeeks: 'XMessagesEveryYWeeks',
};
